import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import "./SolutionsFAQ.css";

const SolutionsFAQ = ({
  faqs = [],
  title = "Frequently Asked Questions",
  subtitle = "Everything you need to know about how TeamGrid works and the value it delivers.",
  defaultOpenIndex = 0,
}) => {
  const [openIndices, setOpenIndices] = useState(
    defaultOpenIndex !== null ? [defaultOpenIndex] : [],
  );

  const toggleFAQ = (index) => {
    setOpenIndices((prev) => {
      if (prev.includes(index)) {
        // Remove index if it's already open
        return prev.filter((i) => i !== index);
      } else {
        // Add index if it's closed
        return [...prev, index];
      }
    });
  };

  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <div className="solutions-faq-container">
      {/* Heading 2 block: flex column, align center */}
      <div className="solutions-faq-heading">
        <span className="inline-block px-5 py-2.5 rounded-full text-xs font-semibold uppercase tracking-wide text-[#0D9488] bg-[#CCFBF1] border border-[#99F6E4] mb-6">
          GOT QUESTIONS?
        </span>
        <h2 className="solutions-faq-title">{title}</h2>
        <p className="solutions-faq-subtitle">{subtitle}</p>
      </div>

      {/* FAQ Items container - gap 16px */}
      <div className="solutions-faq-items">
          {faqs.map((faq, index) => {
            const isOpen = openIndices.includes(index);
            return (
              <motion.div
                key={index}
                className={`solutions-faq-item ${
                  isOpen ? "solutions-faq-item-open" : ""
                }`}
                initial={false}
                transition={{ duration: 0.3 }}
              >
                <div className="solutions-faq-item-content">
                  <button
                    className="solutions-faq-question-button"
                    onClick={() => toggleFAQ(index)}
                  >
                    <h3 className="solutions-faq-question">{faq.question}</h3>
                    <span className="solutions-faq-icon-wrapper">
                      {isOpen ? (
                        <Minus className="solutions-faq-icon" />
                      ) : (
                        <Plus className="solutions-faq-icon" />
                      )}
                    </span>
                  </button>

                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="solutions-faq-answer-wrapper"
                      >
                        <p className="solutions-faq-answer">{faq.answer}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </motion.div>
            );
          })}
        </div>
    </div>
  );
};

export default SolutionsFAQ;
